/**
 * 将网关返回的 HTML 错误页（如 nginx 502）转为对用户可读的短文案，避免整段 HTML 出现在 UI。
 */
export function sanitizeUserFacingHttpErrorMessage(status: number, raw: string | undefined | null): string {
  if (raw == null || raw === '') {
    if (status === 502 || status === 503 || status === 504) {
      return '服务暂时不可用，请稍后重试。若持续出现，请联系管理员。';
    }
    return `请求失败（${status}）`;
  }
  const m = String(raw).trim();
  const looksLikeHtml =
    m.length > 120 &&
    (/<\s*html/i.test(m) || (m.includes('<') && m.includes('</')) || /<title>/i.test(m));
  if (looksLikeHtml) {
    if (status === 502 || status === 503 || status === 504) {
      return '服务暂时不可用，请稍后重试。若持续出现，请联系管理员。';
    }
    return `请求失败（${status}），请稍后重试。`;
  }
  return m.length > 1200 ? `${m.slice(0, 400)}…` : m;
}
